module.exports = __webpack_public_path__ + "static/digital-f2b8d8ba29decc5a1099d778b1b7ad82.webp";